import { Inject, Optional, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/providers/data.service';
import { QuestionService } from 'src/app/providers/question/question.service';

@Component({
  selector: 'app-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrls: ['./question-modal.component.scss'],
  providers: [DataService]
})
export class QuestionModalComponent implements OnInit {
  questionForm: FormGroup;
  // public answers: [];
  correct: boolean;
  editing: boolean = false;
  public iscorrect: boolean = false;
  
  public dataLevelList$: Observable<[]>;
  public dataSubjectList$: Observable<[]>;
  public dataQuestionDifficultyList$: Observable<[]>;
  public dataModifierList$: Observable<[]>;

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<QuestionModalComponent>,
    public dataService: DataService,
    private questionService: QuestionService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    if (!this.data.id) {
      this.createForm();
    } else {
      this.editForm();
      this.editing = true;
    }
  }
  ngOnInit(): void {
    //level list
    this.dataLevelList$ = this.dataService.LevelList;
    this.dataService.getLevelData().subscribe();

    //subject list
    this.dataSubjectList$ = this.dataService.SubjectList;
    this.dataService.getSubjectData().subscribe();

    //question difficulty list
    this.dataQuestionDifficultyList$ = this.dataService.QuestionDifficultyList;
    this.dataService.getQuestionDifficultyData().subscribe();

    //Modifier List
    this.dataLevelList$ = this.dataService.ModifierList;
    this.dataService.getModifierData().subscribe();
  }

  createForm() {
    this.questionForm = new FormGroup({
      sysRef: new FormControl(),
      questiontext: new FormControl(),
      //Level_SysRef: new FormControl(),
      Subject_SysRef: new FormControl(),
      //QuestionDifficulty_SysRef: new FormControl()
    });

    this.questionForm = this.fb.group({
      sysRef: [],
      questiontext: ['', [Validators.required]],
      //Level_SysRef: ['', [Validators.required]],
      Subject_SysRef: ['', [Validators.required]],
      //QuestionDifficulty_SysRef: ['', [Validators.required]],
      answers: this.fb.array([]),
      modifiers: this.fb.array([])
    })

  }

  editForm() {
      this.questionForm = new FormGroup({
        sysRef: new FormControl(),
        questiontext: new FormControl(),
        //Level_SysRef: new FormControl(),
        Subject_SysRef: new FormControl(),
        //QuestionDifficulty_SysRef: new FormControl()
      });

      this.questionForm = this.fb.group({
        sysRef: [this.data.id],
        questiontext: [this.data.questiontext, [Validators.required]],
        //Level_SysRef: [this.data.Level_SysRef, [Validators.required]],
        Subject_SysRef: [this.data.Subject_SysRef, [Validators.required]],
        //QuestionDifficulty_SysRef: [this.data.QuestionDifficulty_SysRef, [Validators.required]],
        answers: this.fb.array([]),
        modifiers: this.fb.array([])
      })

    this.reAddAnswer();
    this.reAddModifiers();
  }


  onSubmit(AddAnother: boolean) {
    console.log('Add Another' + AddAnother)

    if (this.editing) {
      console.log('Calling Editing')
      this.edit(AddAnother);
    } else {
      console.log('Callling Add')
      this.addAnswer(AddAnother);
    }
  }

  addAnswer(AddAnother: boolean) {
    console.log(this.questionForm.value);

    this.questionService.addQuestion(this.questionForm.value)
      .subscribe(
        data => {
          if (AddAnother) {
            this.questionForm.reset();
          } else {
            this.onNoClick();
          }
          return data;
        },
        err => { alert("Invalid data"); console.log(err) }
      );
  }

  edit(AddAnother: boolean) {
    console.log(this.questionForm.value);

    this.questionService.editQuestion(this.data.id,this.questionForm.value)
      .subscribe(
        data => {
          if (AddAnother) {
            this.questionForm.reset();
          } else {
            this.onNoClick();
          }
          return data;
        },
        err => { alert("Invalid data"); console.log(err) }
      );
  }

  answers(): FormArray {
    return this.questionForm.get("answers") as FormArray
  }

  Modifiers(): FormArray {
    return this.questionForm.get("modifiers") as FormArray
  }

  newAnswer(): FormGroup {
    return this.fb.group({
      answerText: new FormControl(),
      isCorrect: [this.iscorrect],
      scoreValue: new FormControl()
    })
  }

  newModifier(): FormGroup {
    return this.fb.group({
      sysRef: new FormControl(),
    })
  }

  reAddAnswer() {
    let Answers = this.data.answers;

    for (let i = 0; i < Answers.length; i++) {
      let tmp = this.fb.group({
        sysRef: new FormControl(Answers[i].sysRef),
        answerText: new FormControl(Answers[i].answerText),
        isCorrect: [Answers[i].isCorrect],
        scoreValue: new FormControl(Answers[i].scoreValue)
      });

      this.answers().push(tmp);
    }
  }

  reAddModifiers() {
    let Modifiers = this.data.modifiers;

    for (let i = 0; i < Modifiers.length; i++) {
      let tmp = this.fb.group({
        sysRef: new FormControl(Modifiers[i].sysRef),
      });

      this.Modifiers().push(tmp);
    }
  }

  addAnswers() {
    this.answers().push(this.newAnswer());
  }

  addModifier() {
    this.Modifiers().push(this.newModifier());
  }

  removeAnswers(i: number) {
    this.answers().removeAt(i);
  }

  removeModifier(i: number) {
    this.Modifiers().removeAt(i);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeValue(){
    this.iscorrect = !this.iscorrect;
  }



}
